var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticStyle:{"transition":"opacity .2s ease-out"},style:({opacity: _vm.intersected ? '' : 0}),attrs:{"src":_vm.srcImage}})}
var staticRenderFns = []

export { render, staticRenderFns }